// extracted by mini-css-extract-plugin
export default {"tupacGrid":"em-z","tupacHeader":"fm-z","tupacHeader2":"gm-z","tupacMenu":"hm-z","tupacMenu2":"im-z","tupacMain":"jm-z","tupacMain2":"km-z"};